var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJava(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#5382A1;}\r\n\t.st1{fill:#E76F00;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.5,38.6c0,0-1.9,1.1,1.3,1.5c3.9,0.4,5.9,0.4,10.1-0.4c0,0,1.1,0.7,2.7,1.3C23.1,45,11,40.7,18.5,38.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.4,33.2c0,0-2.1,1.6,1.1,1.9c4.1,0.4,7.4,0.5,13.1-0.6c0,0,0.8,0.8,2,1.2C22,39.1,9.1,36,17.4,33.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.2,24.1c2.4,2.7-0.6,5.2-0.6,5.2s6-3.1,3.2-7c-2.6-3.6-4.5-5.4,6.1-11.6C36,10.7,19.2,14.9,27.2,24.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.9,42.5c0,0,1.4,1.1-1.5,2c-5.5,1.7-23,2.2-27.9,0.1c-1.7-0.8,1.5-1.8,2.6-2c1.1-0.2,1.7-0.2,1.7-0.2 c-1.9-1.4-12.6,2.7-5.4,3.9C28.9,49.4,45,44.8,39.9,42.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.4,27.6c0,0-8.9,2.1-3.2,2.9c2.4,0.3,7.3,0.3,11.8-0.1c3.7-0.3,7.4-1,7.4-1s-1.3,0.6-2.2,1.2 c-9,2.4-26.5,1.3-21.5-1.2C16,27.4,19.4,27.6,19.4,27.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.4,36.6c9.2-4.8,4.9-9.4,2-8.7c-0.7,0.2-1.1,0.3-1.1,0.3s0.3-0.4,0.8-0.6c5.9-2.1,10.4,6.1-1.9,9.3 C35.2,36.8,35.4,36.7,35.4,36.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.9,0.7c0,0,5.1,5.1-4.8,12.9c-8,6.3-1.8,9.9,0,14c-4.6-4.2-8.1-7.9-5.8-11.3C22.6,11.2,31.9,8.8,29.9,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.3,49.5c8.8,0.6,22.4-0.3,22.7-4.5c0,0-0.6,1.6-7.3,2.8c-7.5,1.4-16.8,1.3-22.3,0.3 C13.4,48.2,14.5,49.1,20.3,49.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJava);
export default __webpack_public_path__ + "static/media/java.7cff4066b956548b5b050e4fd186db6c.svg";
export { ForwardRef as ReactComponent };